$(function () {

    console.log('hi from Edward');
    if($('.page--warranty').length != 0){
        console.log('warranty claim');
        var baseOptions = {
            autoClose: true,
            dateFormat: 'dd-mm-yyyy',
            position: "top left",
            language: 'en',
            maxDate: new Date()
        };

        let manufactureDate = null;
        let installationDate = null;

        $('#Form_WarrantyClaimForm_ManufactureDate').datepicker({
            autoClose: true,
            dateFormat: 'dd-mm-yyyy',
            position: "top left",
            language: 'en',
            maxDate: new Date(),
            minDate: new Date(new Date().getTime() - 12 * 365 * 24 * 60 * 60 * 1000),

            onSelect: function (fd, date) {
                let dateTimestamp = date.getTime();
                manufactureDate = new Date(dateTimestamp);
                dateTimestamp += 13 * 365 * 24 * 60 * 60 * 1000;
                let today = new Date();
                today = today.getTime();

                if(dateTimestamp < today){
                    $('#Form_WarrantyClaimForm_ManufactureDate').addClass('error');
                    if($('#Form_WarrantyClaimForm_ManufactureDate_Holder .error-message').length == 0){
                        $('#Form_WarrantyClaimForm_ManufactureDate_Holder').append('<div class="error error-message body-copy small">The Rheem warranty term has expired – please contact Rheem on 0800 657 336</div>');
                    }
                }else{
                    $('#Form_WarrantyClaimForm_ManufactureDate').removeClass('error');
                    $('#Form_WarrantyClaimForm_ManufactureDate_Holder').find('.error-message').remove();

                    $('#Form_WarrantyClaimForm_InstallationDate').datepicker().data('datepicker').update('minDate', date);
                    $('#Form_WarrantyClaimForm_ComplaintDate').datepicker().data('datepicker').update('minDate', date);
                }


            }
        });
        /*$("#Form_WarrantyClaimForm_ManufactureDate").onSelect(function(){
            console.log($(this).val());

        });*/

        $('#Form_WarrantyClaimForm_InstallationDate').datepicker({
            autoClose: true,
            dateFormat: 'dd-mm-yyyy',
            position: "top left",
            language: 'en',
            maxDate: new Date(),
            onSelect: function (fd, date) {
                installationDate = new Date(date.getTime());
                //check if installation date is more than 6 months from manufacture date
                let sixMonths = 6 * 30 * 24 * 60 * 60 * 1000;
                let manufactureDateTimeStamp = manufactureDate.getTime() + sixMonths;

                if(installationDate.getTime() > manufactureDateTimeStamp){
                    if($('#Form_WarrantyClaimForm_InstallationDate_Holder .message').length == 0){
                        $('#Form_WarrantyClaimForm_InstallationDate_Holder').append('<div class="message label-red body-copy small mt-2">Proof of installation date at site address will be required before warranty cover will be considered</div>');
                    }else{
                        $('#Form_WarrantyClaimForm_InstallationDate_Holder').find('.message').remove();
                    }
                }

                $('#Form_WarrantyClaimForm_ComplaintDate').datepicker().data('datepicker').update('minDate', date);
            }
        });
        $('#Form_WarrantyClaimForm_ComplaintDate').datepicker(baseOptions);
        //$('#Form_WarrantyClaimForm').attr('target', '_blank');

        ///$("input[name='CylinderToBe']").change();

        $("select[name='UserType']").change(function(){
            $('.user-info').hide();
            $("#Form_WarrantyClaimForm_Name_Holder .error-message").remove();
            $("#Form_WarrantyClaimForm_Name_Holder .error").removeClass('error');
            let type = $("select[name='UserType']").val();

            if(type == 'Authorised Rheem Service Centre'){
                $('.service-info').show();
                $('.nameInput label').html('Company Name');
            }
            if(type == 'Non-Rheem Service Company'){
                $('.non-service-info').show();
                $('.nameInput label').html('Service Company Name');
            }

            if(type == 'Merchant'){
                $('.merchant-info').show();
                $('.nameInput label').html('Merchant Name');
            }

            if(type == 'Plumber'){
                $('.merchant-info').show();
                $('.nameInput label').html('Plumber Business Name');
            }

            if(type == 'Product Owner'){
                $('.nameInput label').html('Name');
            }
        });

        $("input[name='CylinderToBe']").change(function(){
            if($("input[name='CylinderToBe']:checked").attr('value') == 'Yes'){
                $('.cylinder-credit-to').show();
                $("input[name='CylinderReimbursement']").change();
            }else{
                $('.cylinder-credit-to').hide();
            }

            if($("input[name='CylinderToBe']:checked").attr('value') == 'Yes' || $("input[name='PartsUsed']:checked").val() == 'Yes') {
                $('.cylinder-merchant-info').show();
            }else{
                $('.cylinder-merchant-info').hide();
            }
        });

        $("input[name='PartsUsed']").change(function(){
            if($("input[name='PartsUsed']:checked").val() == 'Yes'){
                $('.field-group-parts-used').show();
            }else{
                $('.field-group-parts-used').hide();
            }
            if($("input[name='PartsUsed']:checked").val() == 'No - to be supplied under warranty'){
                $('.field-group-parts-warranty').show();
            }else{
                $('.field-group-parts-warranty').hide();
            }

            if($("input[name='CylinderToBe']:checked").attr('value') == 'Yes' || $("input[name='PartsUsed']:checked").val() == 'Yes') {
                $('.cylinder-merchant-info').show();
            }else{
                $('.cylinder-merchant-info').hide();
            }

        });

        $("input[name='CylinderReimbursement']").change(function(){
            if($("input[name='CylinderReimbursement']:checked").val() == 'Credit'){
                $('.cylinder-credit-to').show();
            }else{
                $('.cylinder-credit-to').hide();
            }
        });


        /*$("input[name='UserType']").change();*/

        $('#Form_WarrantyClaimForm').submit(function (e) {
            e.preventDefault();
            let _form = this;
            let hasError = false;

            $(".error-message").remove();
            $(".error").removeClass('error');

       /*     if($("input[name='UserType']:checked").length == 0){
                $('#Form_WarrantyClaimForm_UserType_Holder').addClass('error');
                $('#Form_WarrantyClaimForm_UserType_Holder').append('<div class="error error-message body-copy small">Please select an option</div>');
            }*/

            $('.field.optionset:visible').each(function () {
                if($(this).find('input[type="radio"]:checked').length == 0){
                    $(this).append('<div class="error error-message body-copy small">Please select an option</div>');
                }
            });

            $('.checkbox.requiredInput input').each(function(){
                if($(this).prop('checked') == false){
                    $(this).closest('div.requiredInput').addClass('error');
                    $(this).closest('div.requiredInput').append('<div class="error error-message body-copy small">Please select to continue</div>');
                }
            });

            $("input.requiredInput, select.requiredInput, textarea.requiredInput").each(function(){
                if(!$(this).val()){
                    hasError = true;
                    $(this).addClass('error');
                    let name = $(this).closest('div.requiredInput').find('label').eq(0).html();
                    $(this).after('<div class="error error-message body-copy small">' + name + ' is required</div>');
                }
            });



            if($('.error:visible').length == 0){
                $(".btn-toolbar .error-message").remove();
                $(_form).unbind('submit');
                $(_form).submit();
            }else{
                if(!$(".btn-toolbar .error-message").length){
                    $(".btn-toolbar").append('<div class="error error-message body-copy small form--error">Unable to send – please review the required fields above</div>');
                }
            }
        });

        $('input.datepicker-input').wrap('<div class="datepicker-wrapper" />');

        $(".datepicker-wrapper").click(function () {
            $(this).find('input').focus();
        });


        var mapOptions = {
            componentRestrictions: {
                country: "nz"
            }
        };

        var claimAddressInput = document.getElementById('Form_WarrantyClaimForm_Address');

        if(claimAddressInput){
            var autocomplete = new google.maps.places.Autocomplete(claimAddressInput, mapOptions);

            autocomplete.addListener('place_changed', function () {
                var place = autocomplete.getPlace();

                for(var i = 0; i < place.address_components.length; i++){
                    var obj = place.address_components[i];

                    if(obj.types.includes("sublocality_level_1") || obj.types.includes("sublocality") ){
                        $("#Form_WarrantyClaimForm_Suburb").val(obj.long_name);
                    }
                    if(obj.types.includes("administrative_area_level_1")){
                        $("#Form_WarrantyClaimForm_City").val(obj.long_name);
                    }

                    if(obj.types.includes("postal_code")){
                        $("#Form_WarrantyClaimForm_Postcode").val(obj.long_name);
                    }
                }
            });
        }

        var shippingAddressInput = document.getElementById('Form_WarrantyClaimForm_PartShippingAddress');
        if(shippingAddressInput){
            var autocomplete2 = new google.maps.places.Autocomplete(shippingAddressInput, mapOptions);

            autocomplete2.addListener('place_changed', function () {
                var place = autocomplete2.getPlace();

                for(var i = 0; i < place.address_components.length; i++){
                    var obj = place.address_components[i];

                    if(obj.types.includes("administrative_area_level_1")){
                        $("#Form_WarrantyClaimForm_PartShippingCity").val(obj.long_name);
                    }

                    if(obj.types.includes("postal_code")){
                        $("#Form_WarrantyClaimForm_PartShippingPostcode").val(obj.long_name);
                    }
                }
            });
        }

    }
    //$('.datepicker-input').datepicker();

});
